/**
 * @desc 启停报警规则(旧版)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertChangeStateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/alert/rule/changeState',
    data,
  });
}

export function mock(
  data: defs.AlertChangeStateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/alert/rule/changeState',
    data,
  });
}
